import { inject, Injectable } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { catchAndLogError, rmaShareReplay } from '@rma/common-ui-rxjs/operators';
import { Environment, PlatformService } from '@rma/generic/util/environment';
import { from, map, Observable, of, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GoogleMapsScriptService {
  private readonly environment = inject(Environment);
  private readonly platformService = inject(PlatformService);

  public appendScript(): Observable<boolean> {
    if (this.platformService.isPlatformBrowser) {
      const loader = new Loader({
        apiKey: this.environment.googleMapKey ?? '',
        version: 'weekly',
        libraries: ['places', 'geometry', 'marker'],
      });

      return from(loader.importLibrary('maps')).pipe(
        map((googleMap) => !!googleMap),
        catchAndLogError<boolean>(of(false)),
        take(1),
        rmaShareReplay(),
      );
    }

    return of(false);
  }
}
